import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useParams, useNavigate } from 'react-router-dom';

const ItemForm = () => {
  var { id } = useParams(); // Получаем id элемента, если он есть (для редактирования)
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    categoryId: '',
    materialId: '',
    widthInCm: 0,
    heightInCm: 0,
    depthInCm: 0,
    article: '',
  });
  const [categories, setCategories] = useState([]); // Список категорий
  const [materials, setMaterials] = useState([]); // Список материалов
  const [error, setError] = useState(''); // Ошибки при отправке формы

  // Загрузка данных элемента (если это редактирование) и списков категорий/материалов
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const res = await api.get(`/items/${id}`);
          setFormData({
            id: res.data.id,
            name: res.data.name,
            categoryId: res.data.category.id,
            materialId: res.data.material.id,
            widthInCm: res.data.widthInCm,
            heightInCm: res.data.heightInCm,
            depthInCm: res.data.depthInCm,
            article: res.data.article,
          });
        }

        // Загрузка списков категорий и материалов
        const [categoriesRes, materialsRes] = await Promise.all([
          api.get('/categories'),
          api.get('/materials'),
        ]);
        setCategories(categoriesRes.data);
        setMaterials(materialsRes.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [id]);

  // Обработка изменения полей формы
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Обработка отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        // Редактирование существующего элемента
        await api.put(`/items/${id}`, formData);
        navigate(`/items/${id}`); // Перенаправляем на страницу товара
      } else {
        // Создание нового элемента
        var res = await api.post('/items', formData);
        navigate(`/items/${res.data}`); // Перенаправляем на страницу товара
      }
    } catch (err) {
      console.error(err);
      setError('Failed to save item. Please try again.');
    }
  };

  return (
    <div className="container mt-4">
      <h2>{id ? 'Редактировать товар' : 'Создать новый товар'}</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        {/* Поле для названия */}
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Название
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        {/* Выбор категории */}
        <div className="mb-3">
          <label htmlFor="categoryId" className="form-label">
            Категория
          </label>
          <select
            className="form-control"
            id="categoryId"
            name="categoryId"
            value={formData.categoryId}
            onChange={handleChange}
            required
          >
            <option value="">Выберете категорию</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        {/* Выбор материала */}
        <div className="mb-3">
          <label htmlFor="materialId" className="form-label">
            Материал
          </label>
          <select
            className="form-control"
            id="materialId"
            name="materialId"
            value={formData.materialId}
            onChange={handleChange}
            required
          >
            <option value="">Выберете материал</option>
            {materials.map((material) => (
              <option key={material.id} value={material.id}>
                {material.name}
              </option>
            ))}
          </select>
        </div>

        {/* Поле для ширины */}
        <div className="mb-3">
          <label htmlFor="widthInCm" className="form-label">
            Ширина (см)
          </label>
          <input
            type="number"
            className="form-control"
            id="widthInCm"
            name="widthInCm"
            value={formData.widthInCm}
            onChange={handleChange}
            required
          />
        </div>

        {/* Поле для высоты */}
        <div className="mb-3">
          <label htmlFor="heightInCm" className="form-label">
            Высота (см)
          </label>
          <input
            type="number"
            className="form-control"
            id="heightInCm"
            name="heightInCm"
            value={formData.heightInCm}
            onChange={handleChange}
            required
          />
        </div>

        {/* Поле для глубины */}
        <div className="mb-3">
          <label htmlFor="depthInCm" className="form-label">
            Глубина (см)
          </label>
          <input
            type="number"
            className="form-control"
            id="depthInCm"
            name="depthInCm"
            value={formData.depthInCm}
            onChange={handleChange}
            required
          />
        </div>

        {/* Поле для WB Card ID */}
        <div className="mb-3">
          <label htmlFor="article" className="form-label">
            Артикул
          </label>
          <input
            type="text"
            className="form-control"
            id="article"
            name="article"
            value={formData.article}
            onChange={handleChange}
          />
        </div>

        {/* Кнопка отправки формы */}
        <button type="submit" className="btn btn-primary">
          {id ? 'Обновить' : 'Создать'}
        </button>
      </form>
    </div>
  );
};

export default ItemForm;